(function(){
  var money = function(c){ return '£' + (c/100).toFixed(2); };
  var threshold = (window.OYSTER && window.OYSTER.freeShipThreshold ? window.OYSTER.freeShipThreshold : 50) * 100;

  // Toast styles for stock / cart messages
  var style = document.createElement('style');
  style.textContent = '.oyster-toast{position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(20px);background:#0F3350;color:#fff;padding:12px 20px;border-radius:8px;font-size:14px;box-shadow:0 6px 24px rgba(0,0,0,.25);opacity:0;transition:opacity .3s,transform .3s;z-index:99999;max-width:90%;text-align:center;}.oyster-toast.show{opacity:1;transform:translateX(-50%) translateY(0);}';
  document.head.appendChild(style);

  function showToast(msg){
    var t = document.createElement('div');
    t.className = 'oyster-toast';
    t.textContent = msg;
    t.setAttribute('role','status');
    document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('show'); });
    setTimeout(function(){ t.classList.remove('show'); setTimeout(function(){ if(t.parentNode) t.parentNode.removeChild(t); }, 300); }, 3500);
  }

  function stockMessage(data){
    if(data && data.description) return data.description;
    if(data && data.message) return data.message;
    return 'Sorry, there isn’t enough stock available.';
  }

  // Mobile menu
  document.addEventListener('click', function(e){
    if(e.target.closest('.menu-toggle') && !e.target.closest('[data-cart-close]')){
      var m = document.querySelector('.menu');
      if(m) m.classList.toggle('open');
    }
  });

  // Cart drawer open/close
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('CartOverlay');
  function openCart(){ if(drawer){drawer.classList.add('open'); overlay.classList.add('open'); refreshCart();} }
  function closeCart(){ if(drawer){drawer.classList.remove('open'); overlay.classList.remove('open');} }
  window.oysterOpenCart = openCart;

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-cart-toggle]')){ e.preventDefault(); openCart(); }
    if(e.target.closest('[data-cart-close]') || e.target.id==='CartOverlay'){ closeCart(); }
  });

  // Quantity stepper: keep +/- buttons in sync with min / max stock
  function syncSteppers(scope){
    (scope||document).querySelectorAll('.qty-stepper').forEach(function(st){
      var input = st.querySelector('input[name=quantity]');
      if(!input) return;
      var val = parseInt(input.value,10)||1;
      var min = parseInt(input.getAttribute('min'),10); if(isNaN(min)) min=1;
      var maxAttr = input.getAttribute('max');
      var max = maxAttr !== null && maxAttr !== '' ? parseInt(maxAttr,10) : null;
      var minus = st.querySelector('[data-qty-minus]');
      var plus = st.querySelector('[data-qty-plus]');
      if(minus) minus.disabled = val <= min;
      if(plus) plus.disabled = (max !== null && !isNaN(max) && val >= max);
    });
  }
  window.oysterSyncSteppers = syncSteppers;

  // Clamp quantity inputs to available stock (max set by the theme when tracked + deny)
  function clampQty(e){
    var input = e.target;
    if(!input || input.name !== 'quantity') return;
    var maxAttr = input.getAttribute('max');
    var val = parseInt(input.value, 10);
    var min = parseInt(input.getAttribute('min'),10); if(isNaN(min)) min=1;
    if(!isNaN(val) && val < min){ input.value = min; }
    if(maxAttr !== null && maxAttr !== ''){
      var max = parseInt(maxAttr, 10);
      if(!isNaN(max) && !isNaN(val) && val > max){ input.value = max > 0 ? max : min; }
    }
    syncSteppers();
  }
  document.addEventListener('input', clampQty);
  document.addEventListener('change', clampQty);

  // Quantity stepper +/- buttons
  document.addEventListener('click', function(e){
    var stepBtn = e.target.closest('[data-qty-plus], [data-qty-minus]');
    if(!stepBtn) return;
    e.preventDefault();
    var stepper = stepBtn.closest('.qty-stepper');
    var input = stepper ? stepper.querySelector('input[name=quantity]') : null;
    if(!input) return;
    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.getAttribute('min'), 10); if(isNaN(min)) min = 1;
    var maxAttr = input.getAttribute('max');
    var max = maxAttr !== null && maxAttr !== '' ? parseInt(maxAttr, 10) : null;
    if(stepBtn.hasAttribute('data-qty-plus')){
      val = val + 1;
      if(max !== null && !isNaN(max) && val > max){ val = max; }
    } else {
      val = val - 1;
      if(val < min){ val = min; }
    }
    input.value = val;
    syncSteppers();
  });

  // Add to cart (product form + sticky add)
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-cart-form], form.oyster-add-form');
    if(!form) return;
    e.preventDefault();

    var errBox = form.querySelector('[data-add-error]');
    if(errBox){ errBox.style.display='none'; errBox.textContent=''; }

    // Clamp requested quantity to available stock before sending
    var qtyInput = form.querySelector('input[name=quantity]');
    if(qtyInput && qtyInput.getAttribute('max')){
      var max = parseInt(qtyInput.getAttribute('max'), 10);
      var val = parseInt(qtyInput.value, 10) || 1;
      if(!isNaN(max)){
        if(max <= 0){
          var m0 = 'This item is out of stock.';
          if(errBox){ errBox.textContent = m0; errBox.style.display='block'; } else { showToast(m0); }
          return;
        }
        if(val > max){ qtyInput.value = max; }
      }
    }

    var btn = form.querySelector('[type=submit]');
    var t = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent='Adding…'; }
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},
      body:new URLSearchParams(new FormData(form))
    }).then(function(r){ return r.json().then(function(data){ return { ok: r.ok, data: data }; }); })
      .then(function(res){
        if(btn){ btn.disabled=false; btn.textContent=t; }
        if(!res.ok){
          var msg = stockMessage(res.data);
          if(errBox){ errBox.textContent = msg; errBox.style.display='block'; } else { showToast(msg); }
          return;
        }
        openCart();
      }).catch(function(){ if(btn){btn.disabled=false; btn.textContent=t;} });
  });

  // Quick-add buttons (single variant + cart recommendations)
  document.addEventListener('click', function(e){
    var qa = e.target.closest('[data-quick-add]');
    if(!qa) return;
    e.preventDefault();
    var id = qa.getAttribute('data-quick-add');
    qa.disabled = true; var t = qa.textContent; qa.textContent='…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
      .then(function(r){ return r.json().then(function(data){ return { ok: r.ok, data: data }; }); })
      .then(function(res){
        qa.disabled=false; qa.textContent=t;
        if(!res.ok){ showToast(stockMessage(res.data)); return; }
        openCart();
      })
      .catch(function(){ qa.disabled=false; qa.textContent=t; });
  });

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(renderCart);
  }
  window.oysterRefreshCart = refreshCart;

  function renderCart(cart){
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function(el){ el.textContent = cart.item_count; });
    var items = document.getElementById('CartItems');
    var foot = document.getElementById('CartFoot');
    var ship = document.getElementById('CartShip');
    var recs = document.getElementById('CartRecs');
    if(!items) return;
    if(cart.item_count === 0){
      items.innerHTML = '<div class="cd-empty">Your bag is empty.<br><br><a class="btn dark-outline" href="/collections/all">Start shopping</a></div>';
      if(foot) foot.style.display='none';
      if(ship) ship.style.display='none';
      if(recs) recs.style.display='none';
      return;
    }
    if(foot) foot.style.display='block';
    if(ship) ship.style.display='block';
    items.innerHTML = cart.items.map(function(it){
      return '<div class="cd-item">'+
        (it.image ? '<img src="'+it.image+'" alt="">' : '')+
        '<div class="ci-info"><div>'+it.product_title+'</div>'+
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div style="color:#9FB8CC;font-size:13px">'+it.variant_title+'</div>' : '')+
        '<div style="color:#9FB8CC">Qty '+it.quantity+' &middot; '+money(it.final_line_price)+'</div>'+
        '<span class="rm" data-remove="'+it.key+'">Remove</span></div></div>';
    }).join('');
    if(foot){
      foot.querySelector('[data-subtotal]').textContent = money(cart.total_price);
    }
    if(ship){
      var remain = threshold - cart.total_price;
      var pct = Math.min(100, (cart.total_price/threshold)*100);
      ship.querySelector('.fill').style.width = pct + '%';
      ship.querySelector('[data-ship-msg]').innerHTML = remain > 0
        ? "You're <b>"+money(remain)+"</b> away from free UK delivery"
        : "🎉 You've unlocked free UK delivery";
    }
    loadRecs(cart);
  }

  // Cart recommendations ("You might also like")
  function loadRecs(cart){
    var wrap = document.getElementById('CartRecs');
    var list = document.getElementById('CartRecsList');
    if(!wrap || !list || !cart.items.length){ if(wrap) wrap.style.display='none'; return; }
    var inCart = cart.items.map(function(i){ return i.product_id; });
    var pid = cart.items[cart.items.length - 1].product_id;
    fetch('/recommendations/products.json?product_id=' + pid + '&intent=related&limit=8')
      .then(function(r){ return r.json(); })
      .then(function(d){
        var prods = (d.products || []).filter(function(p){ return inCart.indexOf(p.id) === -1; }).slice(0, 3);
        if(!prods.length){ wrap.style.display='none'; return; }
        list.innerHTML = prods.map(function(p){
          var v = (p.variants && p.variants[0]) ? p.variants[0] : null;
          var img = p.featured_image || (p.images && p.images[0]) || '';
          var addable = v && v.available !== false;
          return '<div class="cd-rec">'+
            '<a href="'+p.url+'">'+(img ? '<img src="'+img+'" alt="" loading="lazy">' : '<span class="cd-rec-noimg"></span>')+'</a>'+
            '<div class="cd-rec-info"><a class="cd-rec-title" href="'+p.url+'">'+p.title+'</a>'+
            '<div class="cd-rec-price">'+money(p.price)+'</div></div>'+
            (addable ? '<button class="cd-rec-add" data-quick-add="'+v.id+'" aria-label="Add '+p.title+' to bag">+</button>' : '')+
          '</div>';
        }).join('');
        wrap.style.display='block';
      }).catch(function(){ wrap.style.display='none'; });
  }

  // Remove item
  document.addEventListener('click', function(e){
    var rm = e.target.closest('[data-remove]');
    if(!rm) return;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:rm.getAttribute('data-remove'),quantity:0})})
      .then(function(r){return r.json();}).then(renderCart);
  });

  // Product gallery thumb swap
  document.addEventListener('click', function(e){
    var th = e.target.closest('[data-thumb]');
    if(!th) return;
    var main = document.querySelector('[data-main-img]');
    if(main) main.src = th.getAttribute('data-thumb');
  });

  // Sticky mobile add-to-bag triggers the product form
  document.addEventListener('click', function(e){
    if(e.target.closest('[data-sticky-add]')){
      var f = document.querySelector('form.oyster-add-form');
      if(f){ if(f.requestSubmit){ f.requestSubmit(); } else { f.dispatchEvent(new Event('submit', {cancelable:true, bubbles:true})); } }
    }
  });

  // init count + steppers on load
  refreshCart();
  syncSteppers();
})();
